export default __webpack_public_path__ + "4d6045b9240adadeb12698f763d4f276.gif";